import { useSyncExternalStore } from 'react'
import { breakpoints } from '#src/breakpoints.ts'

export function useIsLg(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(LG_MEDIA_QUERY).matches,
    () => false
  )
}

function subscribe(callback: () => void): () => void {
  const matchMedia = window.matchMedia(LG_MEDIA_QUERY)

  // Use deprecated `addListener` and `removeListener` to support Safari < 14 (#135)
  if (matchMedia.addListener) {
    matchMedia.addListener(callback)
  } else {
    matchMedia.addEventListener('change', callback)
  }

  return () => {
    if (matchMedia.removeListener) {
      matchMedia.removeListener(callback)
    } else {
      matchMedia.removeEventListener('change', callback)
    }
  }
}

const LG_MEDIA_QUERY = `(min-width: ${breakpoints.lg}rem)`
